import { render, staticRenderFns } from "./AllRecords.vue?vue&type=template&id=e7fcd86a&scoped=true"
import script from "./allrecords.js?vue&type=script&lang=js&external"
export * from "./allrecords.js?vue&type=script&lang=js&external"
import style0 from "./allrecords.scss?vue&type=style&index=0&id=e7fcd86a&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7fcd86a",
  null
  
)

export default component.exports